<template>
  <div v-bind:class="!record.active ? 'close': ''">
    <div @click="goToDetail" class="pointer">
      <div class="record-head-diary">
        <div class="record-left">
          <span class="chatclass" v-bind:class="record.data.TradeType == 1 ? 'up':'down'">
            <v-icon
              size="18"
              class="mr-1"
              v-bind:class="record.data.TradeType == 1 ? 'up':'down'"
            >{{symbol}}</v-icon>
            <b>
              <span v-if="record.data.TradeType == 1">Open Long</span>
              <span v-else>Open Short</span>
            </b>
          </span>
          <span>
            |
            {{openTime}}
            |
            <span  class="mr-2">{{record.data.Quantity}} pcs</span>
            <v-tooltip v-if="record.data._prepare" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" color="#4dbac0" class="mr-1">hourglass_empty</v-icon>
              </template>
              <span>prepared trade</span>
            </v-tooltip>

            <v-tooltip v-if="record.data._entryLevel" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" color="#4dbac0" class="mr-1">calendar_view_day</v-icon>
              </template>
              <span>trade in zone</span>
            </v-tooltip>
          </span>
        </div>
        <div class="record-right-diary">
          <span class="text-grey mx-1">Actual P/L:</span>
          <span
            v-if="!record.active"
            class="trades-pl"
            v-bind:class="record.data.OpenProfitLoss > 0 ? 'up' : 'down'"
          >$ {{record.data.OpenProfitLoss.toFixed(2)}}</span>
          <v-btn
            v-else
            x-small
            v-bind:color="record.data.OpenProfitLoss > 0 ? '#79C04D': (record.data.OpenProfitLoss < 0 ?'#E62163' : '#808F9C')"
          >${{record.data.OpenProfitLoss.toFixed(2)}}</v-btn>
        </div>

        
      </div>
      <div class="record-body ml-6">
        <b>{{record.data.Symbol.user}}</b>
        <div class="float-left width-full">
          <TextSlicer v-if="record.data.description" :text="record.data.description" :maxLength="200" />
        </div>
      </div>
      
    </div>
    
  </div>
</template>

<script>
//import Avatar from "vue-avatar";
//import MenuCard from "@/components/menuCard";
var moment = require("moment-timezone");
import TextSlicer from "@/components/textSlicer.vue";
export default {
  components: {
    TextSlicer
    //Avatar,
    //MenuCard
  },
  props: ["record"],
  data() {
    return {
      type: "",
      symbol: "",
      mainClass: "",
      fromNow: moment
        .tz(this.record.created, this.$store.getters.timezone)
        .fromNow()
    };
  },
  methods: {
    goToDetail() {
      return this.$router.push({ path: "/trades/" + this.record.user.username +"/"+ this.record.data.openTimestamp});
    },
    routeUser() {
      return this.$router.push({ path: "/user/" + this.record.user.username });
    },
    replyName(val) {
      this.$emit("reply_to", val);
    }
  },
  mounted() {
    if (this.record.data.TradeType == 1) {
      this.symbol = "trending_up";
    } else {
      this.symbol = "trending_down";
    }
    // updating record time
    setInterval(() => {
      var value = this.record.created;
      this.fromNow = moment.tz(value, this.$store.getters.timezone).fromNow();
    }, 1000);
  },

  computed: {
    openTime() {
      var value = this.record.created;
      return moment.tz(value, this.$store.getters.timezone).format("HH:mm");
    },

    qtyReturned() {
      if (this.record.Quantity) return this.record.Quantity;
      else return this.record.EntryQuantity;
    }
  }
};
</script>

<style scoped>
.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}

.close {
  opacity: 0.4;
}
</style>
